import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './OrderBookPage.module.scss';
import DataGrid, { Export, Column, Scrolling, Sorting } from 'devextreme-react/data-grid';
import { TableFooter } from '../../components/TableFooter';
import { HeadTitle } from '../../components/HeadTitle';
import { Header } from '../../components/Header';
import { TableHeader } from '../../components/TableHeader';
import { OrderBookFilter } from '../OrderBookFilter';
import { getOrderBook } from '../../api/order-book';
import { Loading } from '../../components/Loading';
import { ORDER_BOOK_ADMIN_AD_GROUP } from '../../util/routeConstants';

// formatter of number cols
const formatQty = {
  type: 'fixedPoint',
  precision: 0
};

const formatPrice = {
  type: 'fixedPoint',
  precision: 4
};

const initialState = {
  queryParam: {},
  title: 'Order Book',
  isLoaded: false,
  isReloading: false,
  data: {},
  error: null
};

var loadingOptions = {
  enabled: false
};

class OrderBookPage extends React.Component {
  constructor(props) {
    super(props);
    this.buyDataGridRef = React.createRef();
    this.sellDataGridRef = React.createRef();
    let collapseOnSearch = window.localStorage.getItem('tps_collapseSearch') === 'true';
    this.state = {

      ...initialState,
      isDownloadInactive: false,
      isSearching: false,
      collapseOnSearch: collapseOnSearch
    };
    this.baseState = this.state;

    this.loadData = this.loadData.bind(this);

    this.setQueryParameters = this.setQueryParameters.bind(this);
    this.handleErrorResults = this.handleErrorResults.bind(this);
    this.clear = this.clear.bind(this);
    this.download = this.download.bind(this);
    this.formatOrderId = this.formatOrderId.bind(this);
    this.formatMpid = this.formatMpid.bind(this);
  }

  get buyDataGrid() {
    var gridRef;
    if (this.buyDataGridRef && this.buyDataGridRef.current) {
      gridRef = this.buyDataGridRef.current.instance;
    }
    return gridRef;
  }

  get sellDataGrid() {
    var gridRef;
    if (this.sellDataGridRef && this.sellDataGridRef.current) {
      gridRef = this.sellDataGridRef.current.instance;
    }
    return gridRef;
  }

  setQueryParameters(queryParamObj, type) {
    const isDownload = type === 'download';
    if (isDownload) {
      this.setState({ queryParam: queryParamObj }, this.download);
    } else {
      this.clear();
      // start the loading icon
      this.setState({ isSearching: true });
      // get only specific trades
      this.setState({ queryParam: queryParamObj }, this.loadData);
    }
  }

  loadData() {
    var filters = this.state.queryParam;
    getOrderBook(filters)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          data: data
        }));
      })
      .catch((error) => {
        // error
        console.log(error);
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
        if (message && (message.includes('504') || message.includes('Gateway'))) {
          message = 'Query Timed out , Please adjust your filter criteria to return a smaller result set.';
        }
        this.handleErrorResults(message);
      });
  }

  clear() {
    this.setState(this.baseState);
  }

  download() {
    if (this.state.isDownloadInactive) return;
    this.setState({ isDownloadInactive: true });
    if (this.sellDataGrid) {
      this.sellDataGrid.exportToExcel(false);
    }
    if (this.buyDataGrid) {
      this.buyDataGrid.exportToExcel(false);
    }
    this.setState({ isDownloadInactive: false });
  }

  handleErrorResults(errorMessage) {
    this.setState(prevState => ({
      isLoaded: true,
      isReloading: false,
      data: {},
      error: errorMessage
    }));
  }

  formatOrderId = (data) => {
    if (data.data.orderId) {
      var { systemType } = this.state.queryParam;
      let route;
      if (systemType === 'ECN') {
        route = '/order';
      } else if (systemType === 'MOON') {
        route = '/nms/order';
      }
      else {
        route = '/idqs/order';
      }
      return <Link style={{ 'color': 'unset' }} to={`${route}?symbol=${this.state.queryParam.symbol}&orderId=${data.data.orderId}`}>{data.data.orderId}</Link>;
    }
    return data.data.orderId;
  };

  formatMpid = (data) => {
    if (data.data.mpid) {
      var { systemType } = this.state.queryParam;
      let route;
      if (systemType === 'ECN') {
        route = '/order';
      } else if (systemType === 'MOON') {
        route = '/nms/order';
      }
      else {
        route = '/idqs/order';
      }
      return <Link style={{ 'color': 'unset' }} to={`${route}?symbol=${this.state.queryParam.symbol}&mpid=${data.data.mpid}`}>{data.data.mpid}</Link>;
    }
    return data.data.mpid;
  };

  render() {
    const data = this.state.data;
    const isDataLoaded = this.state.isLoaded && data && data.openBuyOrders && data.openSellOrders && (data.openBuyOrders.length > 0 || data.openSellOrders.length > 0);
    const systemType = this.state.queryParam && this.state.queryParam.systemType || '';
    const symbol = this.state.queryParam && this.state.queryParam.symbol || '';
    const validUser = this.props.validUser || [];
    const isOrderBookAdmin = validUser.includes(ORDER_BOOK_ADMIN_AD_GROUP)

    return (
      <div>
        <HeadTitle title={this.state.title} />
        <Header title={this.state.title} />
        <OrderBookFilter search={this.setQueryParameters}
          isDataLoaded={isDataLoaded}
          isDownloadInactive={this.state.isDownloadInactive}
        />

        {this.state.isSearching &&

          <Loading
            type='table'
            data={data && data.openBuyOrders && data.openBuyOrders.concat(data.openSellOrders)}
            loaded={this.state.isLoaded}
            reloading={this.state.isReloading}
            error={this.state.error}
            emptyMessage='No results found.' >
            <div>
              <div className={styles.dataContainer}>
                <div key='buyInfo'>
                  <TableHeader headerUpperCase={false}
                    header={'Buys'}
                    tableHeaderMargin={false}
                    bottomBorderOnly={false}
                    topBorderOnly={false}
                  />

                  <DataGrid
                    id='orderBookBuysContainer'
                    className={classNames(styles.gridContainer, {
                      [styles.collapseGrid]: this.state.collapseOnSearch
                    })}
                    ref={this.buyDataGridRef}
                    dataSource={data.openBuyOrders}
                    allowColumnReordering
                    hoverStateEnabled
                    columnAutoWidth
                    rowAlternationEnabled
                    showBorders
                    repaintChangesOnly
                    loadPanel={loadingOptions}
                  >
                    <Scrolling mode='infinite' rowRenderingMode='virtual' preloadEnabled />
                    <Sorting mode='none' />
                    <Column dataField='price' caption='Price' format={formatPrice} alignment={'right'} />
                    <Column dataField='qty' caption='Qty' format={formatQty} alignment={'right'} />
                    {isOrderBookAdmin && <Column dataField='displayQty' caption='Show Qty' format={formatQty} alignment={'right'} />}
                    <Column dataField='tag' caption='FIX Tags' />
                    <Column dataField='orderId' caption='Ord ID' cellRender={this.formatOrderId} />
                    {isOrderBookAdmin && <Column dataField='mpid' caption='MPID' cellRender={this.formatMpid} />}
                    <Export enabled fileName={`${systemType}-${symbol}-order-book-buy`} />
                  </DataGrid>
                  {data && data.openBuyOrders && data.openBuyOrders.length > 0 && <TableFooter totalResults={data.openBuyOrders.length} />}
                </div>

                <div key='sellInfo'>


                  <TableHeader headerUpperCase={false}
                    header={'Sells'}
                    tableHeaderMargin={false}
                    bottomBorderOnly={false}
                    topBorderOnly={false}
                  />

                  <DataGrid
                    id='OrderBookBuysContainer'
                    className={classNames(styles.gridContainer, {
                      [styles.collapseGrid]: this.state.collapseOnSearch
                    })}
                    ref={this.sellDataGridRef}
                    dataSource={data.openSellOrders}
                    allowColumnReordering
                    hoverStateEnabled
                    columnAutoWidth
                    rowAlternationEnabled
                    showBorders
                    repaintChangesOnly
                    loadPanel={loadingOptions}
                  >
                    <Scrolling mode='infinite' rowRenderingMode='virtual' preloadEnabled />
                    <Sorting mode='none' />
                    <Column dataField='price' caption='Price' format={formatPrice} alignment={'right'} />
                    <Column dataField='qty' caption='Qty' format={formatQty} alignment={'right'} />
                    {isOrderBookAdmin && <Column dataField='displayQty' caption='Show Qty' format={formatQty} alignment={'right'} />}
                    <Column dataField='tag' caption='FIX Tags' />
                    <Column dataField='orderId' caption='Ord ID' cellRender={this.formatOrderId} />
                    {isOrderBookAdmin && <Column dataField='mpid' caption='MPID' cellRender={this.formatMpid} />}
                    <Export enabled fileName={`${systemType}-${symbol}-order-book-sell`} />
                  </DataGrid>
                  {data && data.openSellOrders && data.openSellOrders.length > 0 && <TableFooter totalResults={data.openSellOrders.length} />}
                </div>
              </div>
            </div>
          </Loading>}
      </div>
    );
  }
}
export default OrderBookPage;
